import { Button, IconButton } from '@scaleaq/scaleui';
import styled, { css } from 'styled-components';

import { colors, responsive } from '@/utils';

import { controlsFadeTransition } from '../cameraStreamControls.tokens.ts';

/** Footprint of a scaleui IconButton size='large', matching the circular buttons in the design. */
const switchButtonSize = '2.25rem';

/**
 * Hidden until the widget itself is hovered or focused, like the other stream controls — the
 * reveal lives with the widget in cameraStreamWidget.styles.ts. Hovering the panel then expands
 * it from the current camera number to the whole group.
 */
export const StyledCameraSwitchPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${responsive.spacing.small};

  border-radius: ${responsive.radius['3xlarge']};
  background-color: transparent;
  opacity: 0;
  pointer-events: none;

  transition:
    background-color ${controlsFadeTransition},
    opacity ${controlsFadeTransition};

  &:hover,
  &:has(:focus-visible) {
    background-color: ${colors.surface.overflow};
  }
`;

/**
 * Collapsed the panel shows only the current camera number, so everything else is taken out of
 * layout (`display: none`, not `visibility`) to let the pill shrink to that single button.
 * Keyboard `:focus-visible` still expands the group; leftover mouse `:focus` after a click
 * must not, or the pill stays open after the pointer leaves.
 */
const hiddenUntilPanelExpanded = css`
  display: none;

  ${StyledCameraSwitchPanel}:hover &,
  ${StyledCameraSwitchPanel}:has(:focus-visible) & {
    display: flex;
  }
`;

export const StyledCameraNumberButton = styled(Button)`
  width: ${switchButtonSize};
  min-width: ${switchButtonSize};
  height: ${switchButtonSize};
  padding: 0;
  border-radius: ${responsive.radius.rounded};

  /* The current camera is the one marked aria-current, so it stays visible while collapsed. */
  &:not([aria-current]) {
    ${hiddenUntilPanelExpanded}
  }
`;

export const StyledNextCameraButton = styled(IconButton)`
  width: ${switchButtonSize};
  height: ${switchButtonSize};
  border-radius: ${responsive.radius.rounded};
  svg {
    color: inherit;
  }

  ${hiddenUntilPanelExpanded}
`;
